"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _widgets = require("./widgets.constants");

Object.keys(_widgets).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _widgets[key];
    }
  });
});

var _widgets2 = require("./widgets.utils");

Object.keys(_widgets2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _widgets2[key];
    }
  });
});